import app from 'app';
import IService from '../IService';

export default IService.extend({
  getNotifications: function () {
    return new Promise((resolve, reject) => {
      const url = app.apiUrl('/api/v1/notifications/settings/me');
      $.ajax({
        url: url,
        type: 'GET',
        error: (error) => {
          if (error && error.responseJSON) {
            app.doctorController.report(error.responseJSON.message, error);
          }
          reject(error);
        },
        success: (response) => {
          console.log('response', response);
          resolve(response.events);
        },
      });
    });
  },

  setNotifications: function (data) {
    const promise = $.Deferred();
    const url = app.apiUrl('/api/v1/notifications/settings/me');
    $.ajax({
      url: url,
      type: 'PUT',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),
      error: $.proxy(function () {}, this),
      success: $.proxy(function (response) {
        promise.resolve(response);
      }, this),
    });
    return promise;
  },

  sendResetEmail: function (email) {
    const promise = $.Deferred();

    fetch(app.authUrl('/api/v1/userCredentials/password/reset'), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        channelId: app.rootStore.state.user.channelId,
        email,
      }),
    })
      .then((res) => {
        if (200 === res.status) {
          promise.resolve();
        } else {
          promise.reject();
        }
      })
      .catch(promise.reject);

    return promise;
  },

  social: function () {
    return app.api.socialProvider.getUserAccounts();
  },

  saveChanges: function (data) {
    const promise = $.Deferred();
    const url = app.apiUrl('/api/v1/users/me');
    $.ajax({
      url: url,
      type: 'PUT',
      contentType: 'application/json',
      data: JSON.stringify(data),

      error: promise.reject,
      success: promise.resolve,
    });
    return promise;
  },
});
